export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.5 70c16.533 0 30-13.467 30-30s-13.467-30-30-30-30 13.467-30 30 13.467 30 30 30zm0-53.333c12.867 0 23.333 10.466 23.333 23.333 0 12.867-10.466 23.333-23.333 23.333-12.867 0-23.333-10.466-23.333-23.333 0-12.867 10.466-23.333 23.333-23.333zm0 40a4.167 4.167 0 100-8.334 4.167 4.167 0 000 8.334zm-3.333-33.334h6.666V45h-6.666V23.333z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "81",
    "height": "80",
    "viewBox": "0 0 81 80",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};